module.exports = __webpack_public_path__ + "media/images/article/facebook-1c2972b8ab07bf4c1e74e4495b8d8e89.png";